import {FuseNavigation} from '@fuse/types';

export const navigation: FuseNavigation[] = [

    {
        id: 'dashboard',
        title: 'Dashboard',
        translate: 'NAV.DASHBOARDS',
        type: 'item',
        icon: 'dashboard',
        url: '/dashboard',
        isActive: false
    },
    {
        id: 'distributor',
        title: 'Distributor',
        translate: 'NAV.DISTRIBUTOR',
        type: 'collapsable',
        icon: 'business',
        isActive: false,
        children: [
            {
                id: 'view_distributor',
                title: 'Distributor List',
                type: 'item',
                url: '/distributor/list',
                isActive: false
            },
            {
                id: 'create_distributor',
                title: 'Add New Distributor',
                type: 'item',
                url: '/distributor/add',
                isActive: false
            },
            {
                id: 'view_distributor_type',
                title: 'Distributor Type List',
                type: 'item',
                url: '/distributor-type/list',
                isActive: false
            },
            {
                id: 'create_distributor_type',
                title: 'Add New Distributor Type',
                type: 'item',
                url: '/distributor-type/add',
                isActive: false
            },
            {
                id: 'view_distributor_request',
                title: 'Pending Distributor List',
                type: 'item',
                url: '/distributor/pending-list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_STOCK_TRANSFER',
                title: 'Distributor Stock Transfer List',
                type: 'item',
                url: '/distributor-stock/transfer-list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_STOCK_WITH_IDLE_TIME',
                title: 'Distributor Stock Activity',
                type: 'item',
                url: '/distributor-stock/slow-item-list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_SAFETY_STOCK',
                title: 'Safety Stock',
                type: 'item',
                url: '/safety-stock/list',
                isActive: false
            },
            {
                id: 'VIEW_PRODUCT_SERIAL_INFO_OF_DISTRIBUTOR_MAIN_STOCK',
                title: 'Distributor Stock Product Info',
                type: 'item',
                url: '/distributor-stock/info',
                isActive: false
            },
            {
                id: 'VIEW_PRODUCT_SERIAL_INFO_OF_DISTRIBUTOR_RETURN_STOCK',
                title: 'Distributor Return Stock Product Info',
                type: 'item',
                url: '/distributor-stock/return-stock-by-serial',
                isActive: false
            }

            ,
            {
                id: 'VIEW_DISTRIBUTOR_ACCOUNT_TRANSACTIONS',
                title: 'Distributor Account Transactions',
                type: 'item',
                url: '/distributor-account-transaction/list',
                isActive: false
            }

        ]
    },
    {
        id: 'DEALER',
        title: 'Dealer',
        translate: 'NAV.DISTRIBUTOR',
        type: 'collapsable',
        icon: 'store',
        isActive: false,
        children: [
            {
                id: 'VIEW_DEALER',
                title: 'Dealer List',
                type: 'item',
                url: '/dealer/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_TYPE',
                title: 'Dealer Type List',
                type: 'item',
                url: '/dealer-type/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_PAYMENT',
                title: 'Dealer Payment List',
                type: 'item',
                url: '/dealer-payment/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_ACCOUNT_TRANSACTIONS',
                title: 'Dealer Account Transactions',
                type: 'item',
                url: '/dealer-account-transactions/list',
                isActive: false
            }
        ]
    },
    {
        id: 'DISTRIBUTION_CENTER',
        title: 'Distribution Center',
        translate: 'NAV.DISTRIBUTION_CENTER',
        type: 'collapsable',
        icon: 'open_with',
        isActive: false,
        children: [
            {
                id: 'VIEW_DISTRIBUTION_CENTER',
                title: 'Distribution Center List',
                type: 'item',
                url: '/distribution-centre/list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTION_CENTER_STOCK',
                title: 'Distribution Center Stock',
                type: 'item',
                url: '/distribution-centre-stock/list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTION_CENTER_STOCK_TRANSACTIONS',
                title: 'Distribution Center Stock Transaction',
                type: 'item',
                url: '/distribution-centre-stock-transaction/list',
                isActive: false
            }

        ]
    },
    {
        id: 'CODE_GENERATOR',
        title: 'Code Generator Rule',
        translate: 'Code Generator Rule',
        type: 'collapsable',
        icon: 'code',
        isActive: false,
        children: [
            {
                id: 'VIEW_CODE_GENERATOR_RULE',
                title: 'Code Generator Rule List',
                type: 'item',
                url: '/code-generator-rule/list',
                isActive: false
            }

        ]
    },

    {
        id: 'customer',
        title: 'Retailer',
        translate: 'NAV.CUSTOMER',
        type: 'collapsable',
        icon: 'store',
        isActive: false,
        children: [
            {
                id: 'view_customer',
                title: 'Retailer List',
                type: 'item',
                url: '/customer/list',
                isActive: false
            },
            {
                id: 'create_customer',
                title: 'Add New Retailer',
                type: 'item',
                url: '/customer/add',
                isActive: false
            },
            {
                id: 'view_customer_type',
                title: 'Retailer Type List',
                type: 'item',
                url: '/customer-type/list',
                isActive: false
            },
            {
                id: 'create_customer_type',
                title: 'Add New Retailer Type',
                type: 'item',
                url: '/customer-type/add',
                isActive: false
            },
            {
                id: 'view_product_serial_info_of_retailer_stock',
                title: 'Retailer Serial Wise Stock',
                type: 'item',
                url: '/retailer-serial-wise-stock/list',
                isActive: false
            },
            {
                id: 'view_product_serial_info_of_retailer_stock',
                title: 'Retailer Serial Wise Stock Count',
                type: 'item',
                url: '/retailer-serial-wise-stock/count-list',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_ACCOUNT_TRANSACTIONS',
                title: 'Retailer Account Transactions',
                type: 'item',
                url: '/customer-account-transaction/list',
                isActive: false
            }
        ]
    },
    {
        id: 'product',
        title: 'Product',
        translate: 'NAV.PRODUCT',
        type: 'collapsable',
        icon: 'local_mall',
        isActive: false,
        children: [
            {
                id: 'view_product',
                title: 'Product List',
                type: 'item',
                url: '/product/list',
                isActive: false
            },
            {
                id: 'create_product',
                title: 'Add New Product',
                type: 'item',
                url: '/product/add',
                isActive: false
            },
            {
                id: 'view_product_line',
                title: 'Product Line List',
                type: 'item',
                url: '/product-line/list',
                isActive: false
            },
            {
                id: 'create_product_line',
                title: 'Add New Product Line',
                type: 'item',
                url: '/product-line/add',
                isActive: false
            },
            {
                id: 'view_product_brand',
                title: 'Product Brand List',
                type: 'item',
                url: '/product-brand/list',
                isActive: false
            },
            {
                id: 'create_product_brand',
                title: 'Add New Product Brand',
                type: 'item',
                url: '/product-brand/add',
                isActive: false
            },
            {
                id: 'view_product_group',
                title: 'Product Group List',
                type: 'item',
                url: '/product-group/list',
                isActive: false
            },
            {
                id: 'create_product_group',
                title: 'Add New Product Group',
                type: 'item',
                url: '/product-group/add',
                isActive: false
            },
            {
                id: 'view_product_type',
                title: 'Product Type List',
                type: 'item',
                url: '/product-type/list',
                isActive: false
            },
            {
                id: 'create_product_type',
                title: 'Add New Product Type',
                type: 'item',
                url: '/product-type/add',
                isActive: false
            },
            {
                id: 'view_tag',
                title: 'Tag List',
                type: 'item',
                url: '/tag/list',
                isActive: false
            },
            {
                id: 'create_tag',
                title: 'Add New Tag',
                type: 'item',
                url: '/tag/add',
                isActive: false
            }
        ]
    },
    {
        id: 'NOTICE_BOARD',
        title: 'Notice Board',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'notifications',
        isActive: false,
        children: [
            {
                id: 'VIEW_NOTICE',
                title: 'Notice List',
                type: 'item',
                url: '/notice-board/list',
                isActive: false
            },
            {
                id: 'VIEW_NOTICE_FOR_OTHERS',
                title: 'Notice Board for Others List',
                type: 'item',
                url: '/notice-board-for-others/list',
                isActive: false
            }
        ]
    },
    {
        id: 'SERVICE_INCOME',
        title: 'Service Income',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'local_atm',
        isActive: false,
        children: [
            {
                id: 'VIEW_SERVICE_INCOME',
                title: 'Service Income List',
                type: 'item',
                url: '/income/list',
                isActive: false
            },
        ]
    },
    {
        id: 'FRIDGE',
        title: 'Fridge',
        translate: 'NAV.DISTRIBUTION_CENTER',
        type: 'collapsable',
        icon: 'kitchen',
        isActive: false,
        children: [
            {
                id: 'VIEW_FRIDGE',
                title: 'Fridge List',
                type: 'item',
                url: '/lovello-fridge/list',
                isActive: false
            }
        ]
    },
    {
        id: 'DAILY_SUMMARY_IMS',
        title: 'IMS',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'local_atm',
        isActive: false,
        children: [
            {
                id: 'DAILY_SUMMARY_IMS_VIEW',
                title: 'IMS List',
                type: 'item',
                url: '/ims/list',
                isActive: false
            },
        ]
    },
    {
        id: 'ASSET',
        title: 'Asset',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'devices_other',
        isActive: false,
        children: [
            {
                id: 'VIEW_ASSET',
                title: 'Asset List',
                type: 'item',
                url: '/asset/list',
                isActive: false
            },
            {
                id: 'VIEW_ASSET_TYPE',
                title: 'Asset Type List',
                type: 'item',
                url: '/asset/type-list',
                isActive: false
            },
            {
                id: 'INJECT_ASSET',
                title: 'Asset Upload',
                type: 'item',
                url: '/asset/retailer-upload',
                isActive: false
            },
            {
                id: 'VIEW_ASSET_CONDITION',
                title: 'Asset Condition List',
                type: 'item',
                url: '/asset/condition-list',
                isActive: false
            },
        ]
    },
    {
        id: 'STOCK_SURVEY',
        title: 'Stock Survey',
        translate: 'NAV.DISTRIBUTION_CENTER',
        type: 'collapsable',
        icon: 'kitchen',
        isActive: false,
        children: [
            {
                id: 'VIEW_STOCK_SURVEY',
                title: 'Stock Survey List',
                type: 'item',
                url: '/stock-survey/list',
                isActive: false
            },
        ]
    },
    {
        id: 'NOTIFICATION',
        title: 'Notification Rule',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'notifications',
        isActive: false,
        children: [
            {
                id: 'VIEW_NOTIFICATION_RULE',
                title: 'Notification Rule List',
                type: 'item',
                url: '/notification-rule/list',
                isActive: false
            }
        ]
    },
    {
        id: 'TRAINING',
        title: 'Training',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'notifications',
        isActive: false,
        children: [
            {
                id: 'VIEW_TRAINING',
                title: 'Training Content',
                type: 'item',
                url: '/training/list',
                isActive: false
            }
        ]
    },
    {
        id: 'SCHEME',
        title: 'Scheme',
        translate: 'NAV.NOTICE',
        type: 'collapsable',
        icon: 'notifications',
        isActive: false,
        children: [
            {
                id: 'VIEW_SCHEME',
                title: 'Scheme List',
                type: 'item',
                url: '/scheme/list',
                isActive: false
            }
        ]
    },
    {
        id: 'order',
        title: 'Order',
        translate: 'NAV.ORDER',
        type: 'collapsable',
        icon: 'shopping_cart',
        isActive: false,
        children: [
            {
                id: 'view_primary_order',
                title: 'Distributor Order List',
                type: 'item',
                url: '/distributor-order/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_ORDER',
                title: 'Dealer Order List',
                type: 'item',
                url: '/dealer-order/list',
                isActive: false
            },
            {
                id: 'VIEW_RETAILER_TO_DEALER_ORDER',
                title: 'Retailer To Dealer Order List',
                type: 'item',
                url: '/retailer-to-dealer-order/list',
                isActive: false
            },
            {
                id: 'VIEW_CREDIT_OPTION',
                title: 'Credit Option List',
                type: 'item',
                url: '/creditOption/list',
                isActive: false
            }
        ]
    },
    {
        id: 'order',
        title: 'Transport',
        translate: 'NAV.ORDER',
        type: 'collapsable',
        icon: 'directions_bike',
        isActive: false,
        children: [
            {
                id: 'VIEW_TRANSPORT_MODE',
                title: 'Transport Mode List',
                type: 'item',
                url: '/distributor-order/transport-mode-list',
                isActive: false
            }
        ]
    },
    {
        id: 'SPECIAL',
        title: 'Tertiary Sales',
        translate: 'NAV.ORDER',
        type: 'collapsable',
        icon: 'euro_symbol',
        isActive: false,
        children: [
            {
                id: 'AKASH_LIST_OF_TERTIARY_SALES',
                title: 'Tertiary Sales List',
                type: 'item',
                url: '/tertiary-sales/list',
                isActive: false
            },
            {
                id: 'LINNEX_VIEW_TERTIARY_SALES',
                title: 'Tertiary Sales List',
                type: 'item',
                url: '/linnex-tertiary-sales/list',
                isActive: false
            }
        ]
    },
    {
        id: 'LEVEL',
        title: 'Level',
        translate: 'NAV.ORDER',
        type: 'collapsable',
        icon: 'sort',
        isActive: false,
        children: [
            {
                id: 'VIEW_LEVEL',
                title: 'Level List',
                type: 'item',
                url: '/level/list',
                isActive: false
            }
        ]
    },
    {
        id: 'invoice',
        title: 'Invoice',
        translate: 'NAV.INVOICE',
        type: 'collapsable',
        icon: 'shopping_cart',
        isActive: false,
        children: [
            {
                id: 'view_distributor_invoice',
                title: 'Distributor Invoice List',
                type: 'item',
                url: '/distributor-invoice/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_INVOICE',
                title: 'Dealer Invoice List',
                type: 'item',
                url: '/dealer-invoice/list',
                isActive: false
            },
            {
                id: 'VIEW_RETAILER_TO_DEALER_INVOICE',
                title: 'Retailer To Dealer Invoice List',
                type: 'item',
                url: '/retailer-to-dealer-invoice/list',
                isActive: false
            }
        ]
    },
    {
        id: 'FMCG_INVOICE',
        title: 'Invoice',
        translate: 'NAV.INVOICE',
        type: 'collapsable',
        icon: 'shopping_cart',
        isActive: false,
        children: [
            {
                id: 'VIEW_RETAILER_INVOICE',
                title: 'Retailer Invoice List',
                type: 'item',
                url: '/fmcg-customer-invoice/invoice-list',
                isActive: false
            }
        ]
    },
    {
        id: 'CENTRAL_STOCK',
        title: 'Central Stock',
        translate: 'NAV.INVOICE',
        type: 'collapsable',
        icon: 'shopping_cart',
        isActive: false,
        children: [
            {
                id: 'VIEW_CENTRAL_STOCK',
                title: 'Central Stock List',
                type: 'item',
                url: '/central-stock/list',
                isActive: false
            },
            {
                id: 'VIEW_TRANSFER_FROM_CENTRAL_STOCK',
                title: 'Central Stock Transfer List',
                type: 'item',
                url: '/central-stock/stock-transfer-list',
                isActive: false
            },
            {
                id: 'VIEW_CENTRAL_STOCK_TRANSACTIONS',
                title: 'Central Stock Transactions',
                type: 'item',
                url: '/central-stock/transaction',
                isActive: false
            }
        ]
    },
    {
        id: 'CAMPAIGN',
        title: 'Campaign',
        translate: 'NAV.INVOICE',
        type: 'collapsable',
        icon: 'event',
        isActive: false,
        children: [
            {
                id: 'VIEW_CUSTOMER_CAMPAIGN',
                title: 'Retailer Campaign List',
                type: 'item',
                url: '/customer-campaign/list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_CAMPAIGN',
                title: 'Distributor Campaign List',
                type: 'item',
                url: '/distributor-campaign/list',
                isActive: false
            },
            {
                id: 'VIEW_RETAILER_TO_DEALER_CAMPAIGN',
                title: 'Retailer To Dealer Campaign List',
                type: 'item',
                url: '/retailer-to-dealer-campaign/list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_CAMPAIGN',
                title: 'Dealer Campaign List',
                type: 'item',
                url: '/dealer-campaign/list',
                isActive: false
            }
        ]
    },
    {
        id: 'delivery',
        title: 'Delivery Challan',
        translate: 'NAV.DELIVERY_CHALLAN',
        type: 'collapsable',
        icon: 'local_shipping',
        isActive: false,
        children: [
            {
                id: 'VIEW_DISTRIBUTOR_DELIVERY',
                title: 'Distributor Challan List',
                type: 'item',
                url: '/distributor-delivery-challan/list',
                isActive: false
            },
            {
                id: 'CREATE_DISTRIBUTOR_DELIVERY',
                title: 'Add New Distributor Challan',
                type: 'item',
                url: '/distributor-delivery-challan/add',
                isActive: false
            },
            {
                id: 'CREATE_DISTRIBUTOR_DELIVERY_BY_PRODUCT_SERIAL',
                title: 'Add New Distributor Challan',
                type: 'item',
                url: '/distributor-delivery-challan/addBySerial',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_DELIVERY',
                title: 'Dealer Challan List',
                type: 'item',
                url: '/dealer-delivery/list',
                isActive: false
            },
            {
                id: 'CREATE_DEALER_DELIVERY',
                title: 'Add New Dealer Challan',
                type: 'item',
                url: '/dealer-delivery/add',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_DELIVERY',
                title: 'Retailer Challan List',
                type: 'item',
                url: '/customer-delivery-challan/list',
                isActive: false
            },
            {
                id: 'CREATE_CUSTOMER_DELIVERY',
                title: 'Add New Retailer Challan',
                type: 'item',
                url: '/customer-delivery-challan/add',
                isActive: false
            },
            {
                id: 'CREATE_CUSTOMER_DELIVERY_BY_PRODUCT_SERIAL',
                title: 'Add New Retailer Challan',
                type: 'item',
                url: '/customer-delivery-challan/addBySerial',
                isActive: false
            },
            {
                id: 'VIEW_RETAILER_TO_DEALER_DELIVERY',
                title: 'Retailer-Dealer Challan List',
                type: 'item',
                url: '/retailer-to-dealer-delivery-challan/list',
                isActive: false
            },
            {
                id: 'CREATE_RETAILER_TO_DEALER_DELIVERY',
                title: 'Add New Retailer-Dealer Challan',
                type: 'item',
                url: '/retailer-to-dealer-delivery-challan/add',
                isActive: false
            }
        ]
    },
    {
        id: 'return',
        title: 'Return',
        translate: 'NAV.RETURN',
        type: 'collapsable',
        icon: 'call_missed',
        isActive: false,
        children: [
            {
                id: 'VIEW_DISTRIBUTOR_RETURN',
                title: 'Distributor Return List',
                type: 'item',
                url: '/distributor-return/list',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_RETURN_BY_SERIAL',
                title: 'Distributor Return List By Product Serial',
                type: 'item',
                url: '/distributor-return/list-by-product-serial',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_RETURN',
                title: 'Retailer Return List',
                type: 'item',
                url: '/customer-return/list',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_RETURN_BY_SERIAL',
                title: 'Retailer Return List By Product Serial',
                type: 'item',
                url: '/customer-return/list-by-product-serial',
                isActive: false
            },

            {
                id: 'VIEW_DISTRIBUTOR_RETURN_REASON',
                title: 'Distributor Return Reason List',
                type: 'item',
                url: '/distributorReturnReason/list',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_RETURN_REASON',
                title: 'Retailer Return Reason List',
                type: 'item',
                url: '/customerReturnReason/list',
                isActive: false
            }
        ]
    },
    {
        id: 'RETAILER_RETURN',
        title: 'Return',
        translate: 'NAV.RETURN',
        type: 'collapsable',
        icon: 'call_missed',
        isActive: false,
        children: [
            {
                id: 'RETAILER_RETURN_VIEW',
                title: 'Return List',
                type: 'item',
                url: '/general-return/list',
                isActive: false
            },
            {
                id: 'RETAILER_RETURN_REASON_VIEW',
                title: 'Retailer Return Reason List',
                type: 'item',
                url: '/customerReturnReason/list',
                isActive: false
            }
        ]
    },

    {
        id: 'payment',
        title: 'Payment',
        translate: 'NAV.PAYMENT',
        type: 'collapsable',
        icon: 'attach_money',
        isActive: false,
        children: [
            {
                id: 'view_distributor_payment',
                title: 'Payment List',
                type: 'item',
                url: '/payment/list',
                isActive: false
            },
            {
                id: 'VIEW_BANKS',
                title: 'Bank List',
                type: 'item',
                url: '/bank/list',
                isActive: false
            },
            {
                id: 'VIEW_BANKS',
                title: 'Bank Upload',
                type: 'item',
                url: '/bank/upload',
                isActive: false
            },
            {
                id: 'add_distributor_payment',
                title: 'Add New Payment',
                type: 'item',
                url: '/payment/add',
                isActive: false
            },
            {
                id: 'view_organization_bank_account',
                title: 'Bank Account List',
                type: 'item',
                url: '/bank-account/list',
                // icon    : 'account_balance',
                isActive: false
            },
            {
                id: 'view_payment_purpose',
                title: 'Payment Purpose List',
                type: 'item',
                url: '/payment-purpose/list',
                isActive: false
            },
            {
                id: 'view_payment_category',
                title: 'Payment Category List',
                type: 'item',
                url: '/payment-category/list',
                isActive: false
            },
            {
                id: 'view_payment_method',
                title: 'Payment Method List',
                type: 'item',
                url: '/payment-method/list',
                isActive: false
            }
        ]
    },
    {
        id: 'ENGAGEMENT',
        title: 'Visit',
        translate: 'NAV.VISIT',
        type: 'collapsable',
        icon: 'directions_bike',
        isActive: false,
        children: [
            {
                id: 'VIEW_DISTRIBUTOR_ENGAGEMENT',
                title: 'Distributor Visit',
                type: 'item',
                url: '/engagement/distributor',
                isActive: false
            },
            {
                id: 'VIEW_CUSTOMER_ENGAGEMENT',
                title: 'Retailer Visit',
                type: 'item',
                url: '/engagement/customer',
                isActive: false
            },
            {
                id: 'VIEW_ROLE_WISE_DAILY_VISIT_TARGET',
                title: 'User Role Wise Visit Target',
                type: 'item',
                url: '/user-role-wise-visit-target/list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_ENGAGEMENT',
                title: 'Project Visit',
                type: 'item',
                url: '/engagement/project',
                isActive: false
            },
            {
                id: 'VIEW_VISIT_TYPE',
                title: 'Visit Type',
                type: 'item',
                url: '/visit/visit-type',
                isActive: false
            },
            {
                id: 'VIEW_VISIT_STATUS',
                title: 'Visit Status',
                type: 'item',
                url: '/visit/visit-status',
                isActive: false
            }
        ]
    },
    {
        id: 'VISITF',
        title: 'Visit Summary',
        translate: 'NAV.VISIT',
        type: 'collapsable',
        icon: 'assessment',
        isActive: false,
        children: [
            {
                id: 'VIEW_VISIT',
                title: 'Distributor Visit Summary',
                type: 'item',
                url: '/visit/distributor',
                isActive: false
            },
            {
                id: 'VIEW_VISIT',
                title: 'Retailer Visit Summary',
                type: 'item',
                url: '/visit/customer',
                isActive: false
            },
            {
                id: 'VIEW_VISIT',
                title: 'Project Visit Summary',
                type: 'item',
                url: '/visit/project',
                isActive: false
            },
            {
                id: 'VIEW_VISIT_TYPE',
                title: 'Visit Type',
                type: 'item',
                url: '/visit/visit-type',
                isActive: false
            },
            {
                id: 'VIEW_VISIT_STATUS',
                title: 'Visit Status',
                type: 'item',
                url: '/visit/visit-status',
                isActive: false
            },
            {
                id: 'VIEW_ROLE_WISE_DAILY_VISIT_TARGET',
                title: 'User Role Wise Visit Target',
                type: 'item',
                url: '/user-role-wise-visit-target/list',
                isActive: false
            }
        ]
    },
    {
        id: 'SAMPLE_REQUISITION',
        title: 'Sample Requisition',
        translate: 'NAV.VISIT',
        type: 'collapsable',
        icon: 'view_week',
        isActive: false,
        children: [
            {
                id: 'VIEW_SAMPLE_REQUISITIONS_FOR_DISTRIBUTOR',
                title: 'Distributor Sample Requisition',
                type: 'item',
                url: '/sample-requisition/distributor',
                isActive: false
            },
            {
                id: 'VIEW_SAMPLE_REQUISITIONS_FOR_RETAILER',
                title: 'Retailer Sample Requisition',
                type: 'item',
                url: '/sample-requisition/retailer',
                isActive: false
            },
            {
                id: 'VIEW_SAMPLE_REQUISITIONS_FOR_PROJECT',
                title: 'Project Sample Requisition',
                type: 'item',
                url: '/sample-requisition/project',
                isActive: false
            }
        ]
    },
    {
        id: 'market',
        title: 'Market Structure',
        translate: 'NAV.MARKET_HIERARCHY',
        type: 'collapsable',
        icon: 'device_hub',
        isActive: false,
        children: []
    },
    {
        id: 'USER_ATTENDANCE',
        title: 'Attendance',
        translate: 'NAV.ATTENDANCE',
        type: 'collapsable',
        icon: 'fingerprint',
        isActive: false,
        children: [
            {
                id: 'view_attendance',
                title: 'Attendance List',
                type: 'item',
                url: '/attendance/list',
                isActive: false
            },
            {
                id: 'VIEW_DAILY_SHIFT',
                title: 'Daily Shift List',
                type: 'item',
                url: '/daily-shift/list',
                isActive: false
            },
            {
                id: 'MOVEMENT_REQUEST_VIEW',
                title: 'Movement List',
                type: 'item',
                url: '/attendance/movement-list',
                isActive: false
            }
        ]
    },
    {
        id: 'HOLIDAY, LEAVE',
        title: 'Leave Management',
        translate: 'NAV.ATTENDANCE',
        type: 'collapsable',
        icon: 'local_hotel',
        isActive: false,
        children: [
            {
                id: 'VIEW_HOLIDAY',
                title: 'Holiday List',
                type: 'item',
                url: '/holiday/list',
                isActive: false
            },
            {
                id: 'VIEW_WEEKEND_REQUEST',
                title: 'Weekend Request List',
                type: 'item',
                url: '/weekend/weekend-request-list',
                isActive: false
            },
            {
                id: 'VIEW_LEAVE_TYPE',
                title: 'Leave Type List',
                type: 'item',
                url: '/leave-type/list',
                isActive: false
            },
            {
                id: 'VIEW_LEAVE_ALLOCATION',
                title: 'Leave Allocation List',
                type: 'item',
                url: '/leave-allocation/list',
                isActive: false
            },
            {
                id: 'VIEW_LEAVE',
                title: 'Leave List',
                type: 'item',
                url: '/leave/list',
                isActive: false
            },
            {
                id: 'VIEW_LEAVE_ACCOUNT',
                title: 'Leave Account List',
                type: 'item',
                url: '/leave-account/leave-account-list',
                isActive: false
            }
        ]
    },
    {
        id: 'EXPENSE_CLAIM',
        title: 'Expense',
        translate: 'NAV.EXPENSE',
        type: 'collapsable',
        icon: 'payment',
        isActive: false,
        children: [
            {
                id: 'VIEW_EXPENSE_CLAIM',
                title: 'Expense Claim List',
                type: 'item',
                url: '/expense-claim/list',
                isActive: false
            },
            {
                id: 'VIEW_EXPENSE_TYPE',
                title: 'Expense Type List',
                type: 'item',
                url: '/expense-type/list',
                isActive: false
            },
            {
                id: 'VIEW_EXPENSE_PURPOSE',
                title: 'Expense Purpose List',
                type: 'item',
                url: '/expense-purpose/list',
                isActive: false
            },
            {
                id: 'VIEW_EXPENSE_SUB_TYPE',
                title: 'Expense Sub Type List',
                type: 'item',
                url: '/expense-sub-type/list',
                isActive: false
            }
        ]
    },
    {
        id: 'DAILY_TA_DA',
        title: 'Daily TA/DA',
        translate: 'NAV.DAILY_TA_DA',
        type: 'collapsable',
        icon: 'money',
        isActive: false,
        children: [
            {
                id: 'VIEW_APPLIED_TA_DA_LIST',
                title: 'TA/DA List',
                type: 'item',
                url: '/ta-da-claim/list',
                isActive: false
            },
            {
                id: 'VIEW_DAILY_TA_DA',
                title: 'TA/DA List',
                type: 'item',
                url: '/ta-da/list',
                isActive: false
            },
            {
                id: 'VIEW_TOUR_ALLOWANCE_CLAIMS',
                title: 'Tour Allowance Claim List',
                type: 'item',
                url: '/tour-allowance-claim/list',
                isActive: false
            },
            {
                id: 'VIEW_TOUR_ALLOWANCE',
                title: 'Tour Allowance List',
                type: 'item',
                url: '/tour-allowance-claim/rule-list',
                isActive: false
            },
            {
                id: 'MANAGE_DA_RULE',
                title: 'DA Rule List',
                type: 'item',
                url: '/da-rule/list',
                isActive: false
            },
            {
                id: 'VIEW_TA_CLAIM_REQUESTS',
                title: 'TA Claim List',
                type: 'item',
                url: '/ta-claim/list',
                isActive: false
            },
            {
                id: 'APPLY_TA_FOR_SUBORDINATE',
                title: 'Apply TA For Subordinates',
                type: 'item',
                url: '/ta-claim/apply-ta-for-subordinates',
                isActive: false
            }
        ]
    },
    {
        id: 'location',
        title: 'Location(Old)',
        translate: 'NAV.LOCATION',
        type: 'collapsable',
        icon: 'place',
        isActive: false,
        children: [
            {
                id: 'view_location',
                title: 'Tracking',
                type: 'item',
                url: '/location/list',
                isActive: false
            },
            {
                id: 'view_location',
                title: 'Time Line By Date Range',
                type: 'item',
                url: '/location/timeline-by-date-range',
                isActive: false
            },
            {
                id: 'view_location',
                title: 'User Last Location',
                type: 'item',
                url: '/location/user-last-location-list',
                isActive: false
            },
            {
                id: 'VIEW_DEALER_LOCATION',
                title: 'Dealer Location',
                type: 'item',
                url: '/location/dealer-location-list',
                isActive: false
            }
        ]
    },
    {
        id: 'location',
        title: 'Location',
        translate: 'NAV.LOCATION',
        type: 'collapsable',
        icon: 'place',
        isActive: false,
        children: [
            {
                id: 'MONITOR_TEAM_TRACKING',
                title: 'Monitor User Timeline',
                type: 'item',
                url: '/location/monitoring-user-timeline',
                isActive: false
            },
            {
                id: 'MONITOR_TEAM_TRACKING',
                title: 'Monitor Last Locations',
                type: 'item',
                url: '/location/monitoring-last-locations',
                isActive: false
            },
            {
                id: 'MONITOR_TEAM_TRACKING',
                title: 'Monitor User Timeline By Date Range',
                type: 'item',
                url: '/location/monitoring-user-timeline-date-range',
                isActive: false
            },
            {
                id: 'MONITOR_TEAM_TRACKING',
                title: 'All User Timeline By Date Range',
                type: 'item',
                url: '/location/all-user-timeline-by-date-range',
                isActive: false
            },
        ]
    },
    {
        id: 'user',
        title: 'User',
        translate: 'NAV.USER',
        type: 'collapsable',
        icon: 'person',
        isActive: false,
        children: [
            {
                id: 'view_user',
                title: 'User List',
                type: 'item',
                url: '/user/list',
                isActive: false
            },
            {
                id: 'create_user',
                title: 'Add New User',
                type: 'item',
                url: '/user/add',
                isActive: false
            },
            {
                id: 'REPORT_ACTIVE_USER_LIST_IN_A_PERIOD',
                title: 'Active User List of a Period',
                type: 'item',
                url: '/user-active-history/active-user-list-of-a-period',
                isActive: false
            }
        ]
    },
    {
        id: 'tour_plan',
        title: 'Tour Plan',
        translate: 'NAV.TOUR_PLAN',
        type: 'collapsable',
        icon: 'event',
        isActive: false,
        children: [
            {
                id: 'view_tour_plan',
                title: 'Tour Plan List',
                type: 'item',
                url: '/tour-plan/list',
                isActive: false
            },
            {
                id: 'manage_tour_plan',
                title: 'Add New Tour Plan',
                type: 'item',
                url: '/tour-plan/add',
                isActive: false
            },
            {
                id: 'VIEW_TOUR_TYPE',
                title: 'Tour Type List',
                type: 'item',
                url: '/tour-type/list',
                isActive: false
            },
            {
                id: 'VIEW_TOUR_PLAN_TARGET',
                title: 'Tour Plan Target List',
                type: 'item',
                url: '/tour-plan/target',
                isActive: false
            }
        ]
    },
    {
        id: 'PJP',
        title: 'PJP',
        translate: 'NAV.TOUR_PLAN',
        type: 'collapsable',
        icon: 'event',
        isActive: false,
        children: [
            {
                id: 'VIEW_PJP',
                title: 'PJP List',
                type: 'item',
                url: '/pjp-plan/list',
                isActive: false
            },
            {
                id: 'VIEW_TOUR_TYPE',
                title: 'Tour Type List',
                type: 'item',
                url: '/tour-type/list-from-pjp',
                isActive: false
            }
        ]
    },
    {
        id: 'ROUTE_PLAN_DATE_WISE',
        title: 'Route Plan',
        translate: 'NAV.TOUR_PLAN',
        type: 'collapsable',
        icon: 'event',
        isActive: false,
        children: [
            {
                id: 'VIEW_DATE_WISE_SECONDARY_ROUTE_PLAN',
                title: 'Route plan List',
                type: 'item',
                url: '/route-plan/list',
                isActive: false
            }
        ]
    },
    {
        id: 'PROJECT',
        title: 'Project',
        translate: 'NAV.TOUR_PLAN',
        type: 'collapsable',
        icon: 'work_outline',
        isActive: false,
        children: [
            {
                id: 'VIEW_PROJECT',
                title: 'Project List',
                type: 'item',
                url: '/project/project-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_PROPERTIES',
                title: 'Project Property List',
                type: 'item',
                url: '/project/project-additional-properties',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_PROPERTIES_VALUE',
                title: 'Project Properties Value List',
                type: 'item',
                url: '/project/project-additional-properties-value',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_TYPE',
                title: 'Project Type List',
                type: 'item',
                url: '/project/project-type-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_OWNER_TYPE',
                title: 'Project Owner Type List',
                type: 'item',
                url: '/project/project-owner-type-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_STATUS',
                title: 'Project Status Type',
                type: 'item',
                url: '/project/project-status-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_CONSULTANT',
                title: 'Project Developer/Consultant List',
                type: 'item',
                url: '/project/project-consultant-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_DEMAND_DOCUMENT_TYPE',
                title: 'Demand Document Type List',
                type: 'item',
                url: '/project/project-demand-document-type-list',
                isActive: false
            },
            {
                id: 'VIEW_PROJECT_DEMAND',
                title: 'Demand List',
                type: 'item',
                url: '/project/project-demand-list',
                isActive: false
            }
        ]
    },
    {
        id: 'MONTHLY_NOC',
        title: 'NOC',
        translate: 'NAV.REPORT',
        type: 'collapsable',
        icon: 'business',
        isActive: false,
        children: [
            {
                id: 'VIEW_MONTHLY_NOC',
                title: 'Retailer Monthly NOC',
                type: 'item',
                url: '/noc/retailer-monthly-noc',
                isActive: false
            }
        ]
    },
    {
        id: 'GEO_HIERARCHY',
        title: 'Geo Hierarchy',
        translate: 'NAV.USER_ROLE',
        type: 'collapsable',
        icon: 'place',
        isActive: false,
        children: [
            {
                id: 'VIEW_GEO_HIERARCHY',
                title: 'Division',
                type: 'item',
                url: '/geo-hierarchy/division',
                isActive: false
            },
            {
                id: 'VIEW_GEO_HIERARCHY',
                title: 'District',
                type: 'item',
                url: '/geo-hierarchy/district',
                isActive: false
            },
            {
                id: 'VIEW_GEO_HIERARCHY',
                title: 'Thana',
                type: 'item',
                url: '/geo-hierarchy/thana',
                isActive: false
            },
            {
                id: 'VIEW_GEO_HIERARCHY',
                title: 'Union/Town',
                type: 'item',
                url: '/geo-hierarchy/union-or-town',
                isActive: false
            }
        ]
    },
    {
        id: 'SEGMENT',
        title: 'Segment',
        translate: 'NAV.REPORT',
        type: 'collapsable',
        icon: 'business',
        isActive: false,
        children: [
            {
                id: 'VIEW_SEGMENT',
                title: 'Segment List',
                type: 'item',
                url: '/segment/list',
                isActive: false
            },
            {
                id: 'VIEW_SUB_SEGMENT',
                title: 'Sub Segment List',
                type: 'item',
                url: '/sub-segment/list',
                isActive: false
            }
        ]
    },
    {
        id: 'target_achievement',
        title: 'Target Achievement',
        translate: 'NAV.TARGET_ACHIEVEMENT',
        type: 'collapsable',
        icon: 'assessment',
        isActive: false,
        children: [
            {
                id: '',
                title: 'Sales',
                type: 'collapsable',
                isActive: false,
                children: [
                    {
                        id: 'V_3_VIEW_DISTRIBUTOR_PRIMARY_SALES_TARGET, V_3_VIEW_DISTRIBUTOR_SECONDARY_SALES_TARGET',
                        title: 'Distributor Sales',
                        type: 'item',
                        url: '/target/distributor-sales',
                        isActive: false,
                    },
                    {
                        id: 'V_3_VIEW_MARKET_PRIMARY_SALES_TARGET, V_3_VIEW_MARKET_SECONDARY_SALES_TARGET',
                        title: 'Market Sales',
                        type: 'item',
                        url: '/target/market-sales',
                        isActive: false,
                    },
                    {
                        id: 'V_3_VIEW_MARKET_PRIMARY_SALES_TARGET_AGGREGATE_MARKET_PRODUCT_LINE_TARGET, V_3_VIEW_MARKET_SECONDARY_SALES_TARGET_AGGREGATE_MARKET_PRODUCT_LINE_TARGET',
                        title: 'Market Sales',
                        type: 'item',
                        url: '/target/market-sales-aggregate',
                        isActive: false,
                    },
                    {
                        id: 'V_3_VIEW_USER_PRIMARY_SALES_TARGET, V_3_VIEW_USER_SECONDARY_SALES_TARGET',
                        title: 'User Sales',
                        type: 'item',
                        url: '/target/user-sales',
                        isActive: false
                    }
                ]
            },
            {
                id: '',
                title: 'Product',
                type: 'collapsable',
                isActive: false,
                children: [
                    {
                        id: 'V_3_VIEW_DISTRIBUTOR_PRODUCT_PRIMARY_SALES_TARGET, V_3_VIEW_DISTRIBUTOR_PRODUCT_SECONDARY_SALES_TARGET',
                        title: 'Distributor Sales',
                        type: 'item',
                        url: '/target/distributor-product-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_MARKET_PRODUCT_PRIMARY_SALES_TARGET, V_3_VIEW_MARKET_PRODUCT_SECONDARY_SALES_TARGET',
                        title: 'Market Sales',
                        type: 'item',
                        url: '/target/market-product-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_USER_PRODUCT_PRIMARY_SALES_TARGET, V_3_VIEW_USER_PRODUCT_SECONDARY_SALES_TARGET',
                        title: 'User Sales',
                        type: 'collapsable',
                        url: '/target/user-product-sales',
                        isActive: false
                    }
                ]
            },
            {
                id: '',
                title: 'Product Line',
                type: 'collapsable',
                isActive: false,
                children: [
                    {
                        id: 'V_3_VIEW_DISTRIBUTOR_PRODUCT_LINE_PRIMARY_SALES_TARGET, V_3_VIEW_DISTRIBUTOR_PRODUCT_LINE_SECONDARY_SALES_TARGET',
                        title: 'Distributor Sales',
                        type: 'item',
                        url: '/target/distributor-product-line-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_MARKET_PRODUCT_LINE_PRIMARY_SALES_TARGET, V_3_VIEW_MARKET_PRODUCT_LINE_SECONDARY_SALES_TARGET',
                        title: 'Market Sales',
                        type: 'item',
                        url: '/target/market-product-line-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_USER_PRODUCT_LINE_PRIMARY_SALES_TARGET, V_3_VIEW_USER_PRODUCT_LINE_SECONDARY_SALES_TARGET',
                        title: 'User Sales',
                        type: 'item',
                        url: '/target/user-product-line-sales',
                        isActive: false
                    }
                ]
            },
            {
                id: '',
                title: 'Product Group',
                type: 'collapsable',
                isActive: false,
                children: [
                    {
                        id: 'V_3_VIEW_DISTRIBUTOR_PRODUCT_GROUP_PRIMARY_SALES_TARGET, V_3_VIEW_DISTRIBUTOR_PRODUCT_GROUP_SECONDARY_SALES_TARGET',
                        title: 'Distributor Sales',
                        type: 'item',
                        url: '/target/distributor-product-group-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_MARKET_PRODUCT_GROUP_PRIMARY_SALES_TARGET, V_3_VIEW_MARKET_PRODUCT_GROUP_SECONDARY_SALES_TARGET',
                        title: 'Market Sales',
                        type: 'item',
                        url: '/target/market-product-group-sales',
                        isActive: false
                    },
                    {
                        id: 'V_3_VIEW_USER_PRODUCT_GROUP_PRIMARY_SALES_TARGET, V_3_VIEW_USER_PRODUCT_GROUP_SECONDARY_SALES_TARGET',
                        title: 'User Sales',
                        type: 'item',
                        url: '/target/user-product-group-sales',
                        isActive: false
                    }
                ]
            },
            {
                id: 'V_4_VIEW_MARKET_TARGET_REPORTS',
                title: 'Market Target',
                type: 'item',
                url: '/target-v4/market-targets',
                isActive: false
            },
            {
                id: 'V_4_VIEW_MARKET_PRODUCT_TARGET_REPORT',
                title: 'Market Product Target',
                type: 'item',
                url: '/target-v4/market-product-targets',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_WISE_PRIMARY_TARGET_ACHIEVEMENT',
                title: 'Market Primary Target',
                type: 'item',
                url: '/target/primary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_PRODUCT_GROUP_WISE_PRIMARY_TARGET_ACHIEVEMENT',
                title: 'Product Group Wise Market Primary Target',
                type: 'item',
                url: '/target/product-group-wise-primary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_PRODUCT_WISE_PRIMARY_TARGET_ACHIEVEMENT',
                title: 'Product Wise Market Primary Target',
                type: 'item',
                url: '/target/product-wise-primary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_WISE_SECONDARY_TARGET_ACHIEVEMENT',
                title: 'Market Secondary Target',
                type: 'item',
                url: '/target/secondary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_PRODUCT_GROUP_WISE_SECONDARY_TARGET_ACHIEVEMENT',
                title: 'Product Group Wise Market Secondary Target',
                type: 'item',
                url: '/target/product-group-wise-secondary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_PRODUCT_WISE_SECONDARY_TARGET_ACHIEVEMENT',
                title: 'Product Wise Market Secondary Target',
                type: 'item',
                url: '/target/product-wise-secondary-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_WISE_DEALER_TARGET_ACHIEVEMENT',
                title: 'Market Dealer Target',
                type: 'item',
                url: '/target/dealer-market-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_MARKET_PRODUCT_GROUP_WISE_DEALER_TARGET_ACHIEVEMENT',
                title: 'Product Group Wise Market Dealer Target',
                type: 'item',
                url: '/target/product-group-wise-dealer-market-sales-target',
                isActive: true
            },
            {
                id: 'VIEW_MARKET_PRODUCT_WISE_DEALER_TARGET_ACHIEVEMENT',
                title: 'Product Wise Market Dealer Target',
                type: 'item',
                url: '/target/product-wise-dealer-market-sales-target',
                isActive: false
            },
            {
                id: 'view_product_wise_target_for_market',
                title: 'Product Wise Sales Target',
                type: 'item',
                url: '/target/product-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_USER_WISE_SECONDARY_TARGET_ACHIEVEMENT',
                title: 'User Secondary Target Achievement',
                type: 'item',
                url: '/target/user-wise-secondary-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_USER_PRODUCT_GROUP_WISE_SECONDARY_TARGET_ACHIEVEMENT',
                title: 'User Secondary Product Group Target Achievement',
                type: 'item',
                url: '/target/user-secondary-product-group-target',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_WISE_PRIMARY_TARGET_ACHIEVEMENT',
                title: 'Distributor Sales Target Achievement',
                type: 'item',
                url: '/target/distributor-sales-target',
                isActive: false
            },
            {
                id: 'VIEW_DISTRIBUTOR_PRODUCT_GROUP_WISE_PRIMARY_TARGET_ACHIEVEMENT',
                title: 'Distributor Product Group Target Achievement',
                type: 'item',
                url: '/target/distributor-product-group-target',
                isActive: false
            },
            {
                id: 'REPORT_MARKET_WISE_RETAILER_DAILY_SALES_COLLECTION_PERFORMANCE',
                title: 'Daily Sales & Collection',
                type: 'item',
                url: '/target/user-self-target',
                isActive: false
            },

        ]
    },
    {
        id: 'SPECIAL',
        title: 'Target Achievement',
        translate: 'NAV.ORGANIZATION',
        type: 'collapsable',
        icon: 'assessment',
        isActive: false,
        children: [
            {
                id: 'AKASH_KPI_TARGET_ACHIEVEMENT',
                title: 'DSR KPI',
                type: 'item',
                url: '/target/dsr-kpi-target-achievement',
                isActive: false
            },
            {
                id: 'AKASH_KPI_TARGET_ACHIEVEMENT',
                title: 'Retailer KPI',
                type: 'item',
                url: '/target/retailer-kpi-target-achievement',
                isActive: false
            }
        ]
    },
    {
        id: 'POI',
        title: 'POI',
        translate: 'NAV.ORGANIZATION',
        type: 'collapsable',
        icon: 'assessment',
        isActive: false,
        children: []
    },
    {
        id: 'ORGANIZATION',
        title: 'Organization',
        translate: 'NAV.ORGANIZATION',
        type: 'collapsable',
        icon: 'admin_panel_settings',
        isActive: false,
        children: []
    },
    {
        id: 'APPROVAL_RULES',
        title: 'Approval Rules',
        translate: 'NAV.ORGANIZATION',
        type: 'collapsable',
        icon: 'star',
        isActive: false,
        children: []
    },
    {
        id: 'report',
        title: 'Report',
        translate: 'NAV.REPORT',
        type: 'group',
        icon: 'bar_chart',
        isActive: false,
        children: [
            {
                id: 'order_report',
                title: 'Order Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: 'report_order_count_and_amount_by_user',
                        title: 'Order Count And Amount By User',
                        type: 'item',
                        url: '/orderReport/order-count-amount-by-user',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRIMARY_ORDER_TRACKING',
                        title: 'Distributor Order Tracking',
                        type: 'item',
                        url: '/orderReport/primary-order-tracking',
                        isActive: false
                    },
                    {
                        id: 'REPORT_SECONDARY_ORDER_TRACKING',
                        title: 'Retailer Order Tracking',
                        type: 'item',
                        url: '/orderReport/secondary-order-tracking',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRIMARY_ORDER_DETAILS_REPORT',
                        title: 'Primary Order Details Report',
                        type: 'item',
                        url: '/orderReport/primary-order-details-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DEALER_ORDER_TRACKING',
                        title: 'Dealer Order Tracking',
                        type: 'item',
                        url: '/orderReport/dealer-order-tracking',
                        isActive: false
                    },
                    {
                        id: 'REPORT_CUSTOMER_ORDERED_PRODUCT_QUANTITY_AND_AMOUNT',
                        title: 'Secondary Order VS Delivery Summary',
                        type: 'item',
                        url: '/orderReport/customer-order-report',
                        isActive: false
                    },

                    {
                        id: 'report_market_daily_sales_summary',
                        title: 'Market Daily Sales Summary',
                        type: 'item',
                        url: '/orderReport/market-daily-sales-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_MARKET_SALES_SUMMARY',
                        title: 'Market Sales Summary',
                        type: 'item',
                        url: '/orderReport/marketSalesSummary',
                        isActive: false
                    },

                    {
                        id: 'report_product_market_daily_sales_summary',
                        title: 'Product Market Daily Sales Summary',
                        type: 'item',
                        url: '/orderReport/product-market-daily-sales-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PRODUCT_MARKET_SALES_SUMMARY',
                        title: 'Product Market Sales Summary',
                        type: 'item',
                        url: '/orderReport/productMarketSalesSummary',
                        isActive: false
                    },
                    {
                        id: 'report_person_daily_sales_summary',
                        title: 'Person Daily Sales Summary',
                        type: 'item',
                        url: '/orderReport/person-daily-sales-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_PERSON_SALES_SUMMARY',
                        title: 'Person Sales Summary',
                        type: 'item',
                        url: '/orderReport/personSalesSummary',
                        isActive: false
                    },
                    {
                        id: 'RETAILER_PRODUCT_GROUP_WISE_SECONDARY_ORDER_REPORT',
                        title: 'Retailer Product Group Wise Secondary Order',
                        type: 'item',
                        url: '/orderReport/retailer-product-wise-secondary-report',
                        isActive: false
                    },
                    {
                        id: 'DISTRIBUTOR_PRODUCT_GROUP_WISE_SECONDARY_ORDER_REPORT',
                        title: 'Distributor Product Group Wise Order Report',
                        type: 'item',
                        url: '/orderReport/distributor-product-group-wise-order-report',
                        isActive: false
                    },
                    {
                        id: 'USER_PRODUCT_GROUP_WISE_SECONDARY_ORDER_REPORT',
                        title: 'User Product Group Wise Secondary Order Report',
                        type: 'item',
                        url: '/orderReport/user-product-group-wise-secondary-order-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'SUMMARY',
                title: 'Summary',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'shopping_cart',
                isActive: false,
                children: [
                    {
                        id: '',
                        title: 'Primary Sales Summary',
                        type: 'collapsable',
                        isActive: false,
                        children: [
                            {
                                id: 'MONTHLY_SALES_SUMMARY_OF_MARKET_PRIMARY_ORDER_SUMMARY',
                                title: 'Market Sales Summary',
                                type: 'item',
                                url: '/orderReport/market-primary-sales-summary',
                                isActive: false
                            },
                            {
                                id: 'MONTHLY_SALES_SUMMARY_OF_MARKET_AND_PRODUCT_GROUP_PRIMARY_ORDER_SUMMARY',
                                title: 'Market Product Group Sales Summary',
                                type: 'item',
                                url: '/orderReport/market-primary-product-group-sales-summary',
                                isActive: false
                            },
                            {
                                id: 'DAILY_SALES_SUMMARY_OF_MARKET_AND_PRODUCT_PRIMARY_ORDER_SUMMARY',
                                title: 'Market Product Daily Sales Summary',
                                type: 'item',
                                url: '/orderReport/primary-market-product-daily-sales-summary',
                                isActive: false
                            }
                        ]
                    },
                    {
                        id: '',
                        title: 'Secondary Sales Summary',
                        type: 'collapsable',
                        isActive: false,
                        children: [
                            {
                                id: 'MONTHLY_SALES_SUMMARY_OF_MARKET_SECONDARY_ORDER_SUMMARY',
                                title: 'Market Sales Summary',
                                type: 'item',
                                url: '/orderReport/market-secondary-sales-summary',
                                isActive: false
                            },
                            {
                                id: 'MONTHLY_SALES_SUMMARY_OF_MARKET_AND_PRODUCT_GROUP_SECONDARY_ORDER_SUMMARY',
                                title: 'Market Product Group Sales Summary',
                                type: 'item',
                                url: '/orderReport/market-secondary-product-group-sales-summary',
                                isActive: false
                            },
                            {
                                id: 'DAILY_SALES_SUMMARY_OF_MARKET_AND_PRODUCT_SECONDARY_ORDER_SUMMARY',
                                title: 'Market Product Daily Sales Summary',
                                type: 'item',
                                url: '/orderReport/secondary-market-product-daily-sales-summary',
                                isActive: false
                            }
                        ]
                    },

                    {
                        id: 'DISTRIBUTOR_S_PRIMARY_ORDER_SUMMARY, DISTRIBUTOR_S_SECONDARY_ORDER_SUMMARY, DISTRIBUTOR_S_PRIMARY_DELIVERY_SUMMARY, DISTRIBUTOR_S_SECONDARY_DELIVERY_SUMMARY',
                        title: 'Distributor Sales Summary',
                        type: 'item',
                        url: '/orderReport/distributor-sales-summary',
                        isActive: false
                    },
                    {
                        id: 'V_2_VIEW_DAILY_MARKET_SALES_PRIMARY_ORDER_SUMMARY, V_2_VIEW_DAILY_MARKET_SALES_SECONDARY_ORDER_SUMMARY, V_2_VIEW_DAILY_MARKET_SALES_PRIMARY_DELIVERY_SUMMARY, V_2_VIEW_DAILY_MARKET_SALES_SECONDARY_DELIVERY_SUMMARY',
                        title: 'Market Sales Summary',
                        type: 'item',
                        url: '/orderReport/daily-market-sales-summary-v2',
                        isActive: false
                    },
                    {
                        id: 'RETAILER_S_SECONDARY_ORDER_SUMMARY, RETAILER_S_SECONDARY_DELIVERY_SUMMARY',
                        title: 'Retailer Sales Summary',
                        type: 'item',
                        url: '/orderReport/retailer-sales-summary',
                        isActive: false
                    }

                ]
            },
            {
                id: 'ENGAGEMENT',
                title: 'Visit Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'description',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_DAILY_ENGAGEMENT_REPORT',
                        title: 'Daily Visit Summary',
                        type: 'item',
                        url: '/engagement-report/daily-engagement-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_ENGAGEMENTS_BY_USER',
                        title: 'Visit By User',
                        type: 'item',
                        url: '/engagement-report/engagement-by-user',
                        isActive: false
                    },
                    {
                        id: 'REPORT_TARGET_AND_VISIT_COUNT_BY_USER',
                        title: 'Target & Visit Count By User',
                        type: 'item',
                        url: '/engagement-report/target-visit-count-by-user',
                        isActive: false
                    },
                    {
                        id: 'REPORT_FIELD_FORCE_MOVEMENT_REPORT_BY_ENGAGEMENT',
                        title: 'Field Force Movement Report',
                        type: 'item',
                        url: '/engagement-report/user-movement-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'PROJECT',
                title: 'Project Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'receipt',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_PRODUCT_DEMAND_VS_SALES_FOR_PROJECT',
                        title: 'Project Demand VS Sales Report',
                        type: 'item',
                        url: '/project-report/project-demand-sales-report',
                        isActive: false
                    },
                    {
                        id: 'PROJECT_SALES_FORECAST_BY_PROJECT',
                        title: 'Project Wise Sales Forecast',
                        type: 'item',
                        url: '/project-report/project-wise-sales-forecast',
                        isActive: false
                    },
                    {
                        id: 'PROJECT_SALES_FORECAST_BY_PRODUCT',
                        title: 'Product Wise Sales Forecast',
                        type: 'item',
                        url: '/project-report/product-wise-sales-forecast',
                        isActive: false
                    }
                ]
            },
            {
                id: 'TOUR_PLAN',
                title: 'Route Plan Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'directions_bus',
                isActive: false,
                children: [
                    {
                        id: 'TOUR_PLAN_ACHIEVEMENT_REPORT',
                        title: 'Route Plan Achievement Report',
                        type: 'item',
                        url: '/route-plan-achievement/report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_TOUR_PLAN_VS_VISIT_DETAILS',
                        title: 'Visit Plan VS Visit Report',
                        type: 'item',
                        url: '/route-plan-achievement/plan-vs-visit-report',
                        isActive: false
                    },
                    {
                        id: 'REPORT_TOUR_PLAN_VS_RETAILER_SALES',
                        title: 'Tour Plan VS Retailer Sales Report',
                        type: 'item',
                        url: '/route-plan-achievement/plan-vs-retailer-sales',
                        isActive: false
                    }
                ]
            },
            {
                id: 'leave_report',
                title: 'Leave Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'local_hotel',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_OF_USER_LEAVE_STAT',
                        title: 'User Leave Account',
                        type: 'item',
                        url: '/report-leave/user-leave-account',
                        isActive: false
                    }
                ]
            },
            {
                id: 'user_attendance_report',
                title: 'Attendance Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'fingerprint',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_ATTENDANCE_AND_TA_DA_SUMMARY',
                        title: 'Attendance And TA DA Summary',
                        type: 'item',
                        url: '/report-attendance/attendanceAndTaDaSummary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_VIEW_ATTENDED_USERS',
                        title: 'Attended User List',
                        type: 'item',
                        url: '/attendance/user-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_VIEW_ATTENDED_USER_WITH_SHIFT',
                        title: 'Attended User Shift Wise Report',
                        type: 'item',
                        url: '/report-attendance/shifting-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DAY_WISE_ATTENDANCE_WITH_SHIFT',
                        title: 'Daily Shift-wise Attendance',
                        type: 'item',
                        url: '/attendance/shift-wise-user-list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_VIEW_ATTENDANCE_REGISTRAR',
                        title: 'Attendance Registry',
                        type: 'item',
                        url: '/attendance/registry',
                        isActive: false
                    },
                    {
                        id: 'REPORT_USER_PRESENCE_COUNT',
                        title: 'Attendance Registrar',
                        type: 'item',
                        url: '/report-attendance/status-registrar',
                        isActive: false
                    }
                ]
            },
            {
                id: 'NOTIFICATION',
                title: 'Notification Log',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'chat_bubble_outline',
                isActive: false,
                children: [
                    {
                        id: 'NOTIFICATION_SMS_REPORT',
                        title: 'SMS Report',
                        type: 'item',
                        url: '/report-sms/sms-report',
                        isActive: false
                    },
                    {
                        id: 'NOTIFICATION_SMS_REPORT_WITH_COST',
                        title: 'SMS Report With Cost',
                        type: 'item',
                        url: '/report-sms/sms-report-with-cost',
                        isActive: false
                    },
                    {
                        id: 'EMAIL_NOTIFICATION_REPORT',
                        title: 'Email Notification History',
                        type: 'item',
                        url: '/email-notification/list',
                        isActive: false
                    },
                ]
            },
            {
                id: 'NOTICE_BOARD',
                title: 'Notice Report',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'chat_bubble_outline',
                isActive: false,
                children: [
                    {
                        id: 'NOTICE_SEEN_REPORT',
                        title: 'Notice Seen Report',
                        type: 'item',
                        url: '/report-notice/notice-seen-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'SECONDARY_SALES_REPORT',
                title: 'Retailer Sales',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'chat_bubble_outline',
                isActive: false,
                children: [
                    {
                        id: 'RETAILER_WISE_DETAILS_SALES_REPORT',
                        title: 'Retailer Wise Details Sales Report',
                        type: 'item',
                        url: '/retailer-sales/list',
                        isActive: false
                    },
                    {
                        id: 'RETAILER_DUE_REPORT_BY_DATE_MARKET_RETAILER_DISTRIBUTOR',
                        title: 'Retailer Due Report',
                        type: 'item',
                        url: '/retailer-sales/due-report',
                        isActive: false
                    },
                    {
                        id: 'RETAILER_ORDER_SUMMARY_BY_CATEGORY_AND_VOLUME',
                        title: 'Order Summary By Category',
                        type: 'item',
                        url: '/retailer-sales/order-summary-by-category',
                        isActive: false
                    },
                    {
                        id: 'ORDER_VS_DELIVERY_FOR_WEB_BY_MARKET_AND_SKU',
                        title: 'Order vs Delivery by Brand and SKU',
                        type: 'item',
                        url: '/retailer-sales/order-vs-delivery-by-brand-and-sku',
                        isActive: false
                    },
                    {
                        id: 'MARKET_ORDER_RETURN_BY_RETAILER_SKU_REPORT',
                        title: 'Market Return Report',
                        type: 'item',
                        url: '/retailer-sales/market-return-report',
                        isActive: false
                    },
                    {
                        id: 'TRADE_SPEND_REPORT_BY_DISTRIBUTOR_AND_BRAND',
                        title: 'Trade Spend Report',
                        type: 'item',
                        url: '/retailer-sales/trade-spend-report',
                        isActive: false
                    },
                    {
                        id: 'NUMERIC_DISTRIBUTION_REPORT_BY_SR_BRAND_WISE',
                        title: 'Numeric Distribution Report',
                        type: 'item',
                        url: '/retailer-sales/numeric-distribution-report',
                        isActive: false
                    },
                    {
                        id: 'CHILLER_OUTLET_SALES_REPORT_BY_RETAILER_BRAND_WISE',
                        title: 'Chiller Outlet Sales Report',
                        type: 'item',
                        url: '/retailer-sales/chiller-outlet-sales-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'expense_claim_report',
                title: 'Expense Claim',
                translate: 'NAV.EXPENSE',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_EXPENSE_CLAIM',
                        title: 'Per User Expense Report',
                        type: 'item',
                        url: '/report-expense-claim/per-user-expense',
                        isActive: false
                    },
                    {
                        id: 'USER_WISE_EXPENSE_CLAIM_SUMMARY_REPORT',
                        title: 'User Wise Expense Summary Report',
                        type: 'item',
                        url: '/user-wise-expense-summary/report',
                        isActive: false
                    },
                    {
                        id: 'USER_WISE_EXPENSE_CLAIM_SUMMARY_REPORT',
                        title: 'User Wise Expense Summary Report By Date',
                        type: 'item',
                        url: '/user-wise-expense-summary/by-date-report',
                        isActive: false
                    },
                    {
                        id: 'EXPENSE_CLAIM_SUMMARY_REPORT',
                        title: 'Expense Claim Summary Report',
                        type: 'item',
                        url: '/report-expense-claim/expense-claim-summary',
                        isActive: false
                    }
                ]
            },
            {
                id: 'stock_report',
                title: 'Distributor',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_STOCK_SUMMARY_BY_PRODUCT_AND_GROUP',
                        title: 'Stock Report',
                        type: 'item',
                        url: '/report-distributor/stock-report',
                        isActive: false
                    },
                    {
                        id: 'DISTRIBUTOR_STOCK_MOVEMENT_REPORT',
                        title: 'Stock Movement Report',
                        type: 'item',
                        url: '/report-distributor/stock-movement',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DISTRIBUTOR_DAILY_SUMMARY',
                        title: 'Distributor Summary',
                        type: 'item',
                        url: '/orderReport/distributor-daily-summary',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DISTRIBUTOR_INVOICE_PAYMENT_COLLECTION',
                        title: 'Distributor Payment Collection Report',
                        type: 'item',
                        url: '/report-distributor/distributor-payment-collection',
                        isActive: false
                    },
                    {
                        id: 'VIEW_DISTRIBUTOR_STOCK_SUMMARY',
                        title: 'Distributor Stock Summary',
                        type: 'item',
                        url: '/report-distributor/stock-summary',
                        isActive: false
                    },
                    {
                        id: 'DISTRIBUTOR_ORDER_VS_DELIVERY_REPORT',
                        title: 'Distributor Order vs Delivery',
                        type: 'item',
                        url: '/report-distributor/order-vs-delivery',
                        isActive: false
                    },
                    {
                        id: 'REPORT_DISTRIBUTOR_WISE_PRIMARY_VS_SECONDARY_BY_BRAND',
                        title: 'Distribution Wise Primary Vs Secondary By Brand Report',
                        type: 'item',
                        url: '/report-distributor/distributor-wise-primary-vs-secondary-by-brand-report',
                        isActive: false
                    },
                ]
            },
            {
                id: 'STOCK',
                title: 'Dealer',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_DEALER_STOCK_SUMMARY_BY_PRODUCT_AND_GROUP',
                        title: 'Stock Report',
                        type: 'item',
                        url: '/report-dealer/stock-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'customer',
                title: 'Retailer',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'store',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_RETAILER_SALES_PERFORMANCE',
                        title: 'Sales Performance',
                        type: 'item',
                        url: '/report-retailer/sales-performance',
                        isActive: false
                    },
                    {
                        id: 'CUSTOMER_ORDER_VS_DELIVERY_REPORT',
                        title: 'Order VS Delivery',
                        type: 'item',
                        url: '/report-retailer/order-vs-delivery',
                        isActive: false
                    },
                    {
                        id: 'RETAILER_CREDIT_REPORT',
                        title: 'Retailer Credit Report',
                        type: 'item',
                        url: '/report-retailer/retailer-credit-report',
                        isActive: false
                    },
                    {
                        id: 'VIEW_ZERO_INVOICED_RETAILER_LIST',
                        title: 'Non Productive Retailer Report',
                        type: 'item',
                        url: '/report-retailer/non-productive-retailer-report',
                        isActive: false
                    },
                    {
                        id: 'WEEKLY_BUYER_OUTLET_REPORT_OF_MONTH_BY_SO',
                        title: 'Weekly Buyer Outlets Report',
                        type: 'item',
                        url: '/report-retailer/weekly-buyer-outlet-report',
                        isActive: false
                    }
                ]
            },
            {
                id: 'central_stock_report',
                title: 'Central Stock',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_PRODUCT_WISE_SUMMARY_FOR_CENTRAL_STOCK',
                        title: 'Product Wise Central Stock Summary',
                        type: 'item',
                        url: '/orderReport/product-stock-summary',
                        isActive: false
                    }
                ]
            },
            {
                id: 'kpi_report',
                title: 'KPI',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'trending_up',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_PERSON_WISE_MONTHLY_KPI',
                        title: 'Person-wise Monthly KPI',
                        type: 'item',
                        url: '/report-kpi/person-wise-monthly-kpi',
                        isActive: false
                    },
                    {
                        id: 'SALES_TEAM_KPI_BY_PLAN_VISIT_SECONDARY_ORDER_DELIVERY',
                        title: 'Sales Team KPI',
                        type: 'item',
                        url: '/report-kpi/sales-team-kpi-list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'invoice_report',
                title: 'Retailer Invoice',
                translate: 'NAV.REPORT',
                type: 'collapsable',
                icon: 'store',
                isActive: false,
                children: [
                    {
                        id: 'REPORT_CUSTOMER_INVOICED_PRODUCT_QUANTITY_AND_AMOUNT',
                        title: 'Retailer Invoiced Product Quantity And Amount',
                        type: 'item',
                        url: '/report-customer-invoice-product/list',
                        isActive: false
                    },
                    {
                        id: 'REPORT_CUSTOMER_INVOICE_PAYMENT_COLLECTION',
                        title: 'Retailer Payment Collection Report',
                        type: 'item',
                        url: '/report-customer-invoice-product/payment-collection',
                        isActive: false
                    },
                    {
                        id: 'REPORT_RETAILER_TO_DEALER_INVOICE_PRODUCT_QUANTITY_AND_AMOUNT',
                        title: 'Retailer To Dealer Invoiced Product Quantity And Amount',
                        type: 'item',
                        url: '/report-customer-invoice-product/retailer-to-dealer-product-and-amount',
                        isActive: false
                    }
                ]
            },
            {
                id: 'target_achievement_report',
                title: 'Target Achievement',
                translate: 'NAV.TARGET_ACHIEVEMENT',
                type: 'collapsable',
                icon: 'assessment',
                isActive: false,
                children: [
                    {
                        id: 'TARGET_ACHIEVEMENT_SUMMARY_OF_PERSON',
                        title: 'Person-wise Summary',
                        type: 'item',
                        url: '/report-target-achievement/person-summary',
                        isActive: false
                    }
                ]
            },
            {
                id: 'DAILY_SUMMARY_IMS',
                title: 'IMS Report',
                translate: 'NAV.TARGET_ACHIEVEMENT',
                type: 'collapsable',
                icon: 'assessment',
                isActive: false,
                children: [
                    {
                        id: 'DAILY_SUMMARY_IMS_DETAILS_REPORT',
                        title: 'IMS Details Report',
                        type: 'item',
                        url: '/report-ims/ims-details-report',
                        isActive: false
                    },
                    {
                        id: 'DAILY_SUMMARY_IMS_SUMMARY_FOR_WEB',
                        title: 'IMS Summary',
                        type: 'item',
                        url: '/ims/summary-by-volume',
                        isActive: false
                    },
                    {
                        id: 'DAILY_SUMMARY_IMS_DETAILS_REPORT',
                        title: 'IMS Summary By Category',
                        type: 'item',
                        url: '/report-ims/summary-by-category',
                        isActive: false
                    },
                    {
                        id: 'DAILY_SUMMARY_IMS_DETAILS_REPORT',
                        title: 'Monthly IMS by SR',
                        type: 'item',
                        url: '/report-ims/monthly-ims-by-sr',
                        isActive: false
                    }
                ]
            },
            {
                id: 'SECONDARY_ORDER_SELLING_PRICE',
                title: 'Order Summary',
                translate: 'NAV.TARGET_ACHIEVEMENT',
                type: 'collapsable',
                icon: 'assessment',
                isActive: false,
                children: [
                    {
                        id: 'ORDER_VOLUME_SUMMARY_WITH_RDT_FOR_WEB',
                        title: 'Order Summary With RDT',
                        type: 'item',
                        url: '/order-volume-summary/list',
                        isActive: false
                    },
                ]
            }

        ]
    },
    {
        id: 'superadmin',
        title: 'Administration',
        translate: 'NAV.SUPERADMIN',
        type: 'group',
        icon: 'settings_applications',
        isActive: false,
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'home',
                url: '/dashboard',
                isActive: false
            },
            {
                id: 'organization',
                title: 'Organization',
                translate: 'NAV.ORGANIZATION',
                type: 'collapsable',
                icon: 'business',
                isActive: false,
                children: [
                    {
                        id: 'organization-list',
                        title: 'Organization List',
                        type: 'item',
                        url: '/organization/list',
                        isActive: false
                    },
                    {
                        id: 'organization-add',
                        title: 'Add New Organization',
                        type: 'item',
                        url: '/organization/add',
                        isActive: false
                    }
                ]
            },
            {
                id: 'dashboard',
                title: 'Bill Pending Organization',
                translate: 'NAV.DASHBOARDS',
                type: 'item',
                icon: 'home',
                url: '/bill-pending-organization/list',
                isActive: false
            },
            {
                id: 'expenseclaimApproveRules',
                title: 'Expense Claim Approval Rules',
                translate: 'NAV.ORGANIZATION',
                type: 'collapsable',
                icon: 'payment',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Expense Claim Approval Rules List',
                        type: 'item',
                        url: '/expense-claim-approval-rules/expense-claim-approval-rules-list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'visitSummaryApprovalRule',
                title: 'Visit Summary Approval Rules',
                translate: 'NAV.ORGANIZATION',
                type: 'collapsable',
                icon: 'directions_bike',
                isActive: false,
                children: [
                    {
                        id: 'list',
                        title: 'Visit Summary Approval Rules List',
                        type: 'item',
                        url: '/visit-summary-approval-rules/list',
                        isActive: false
                    }
                ]
            },
            {
                id: 'market-level',
                title: 'Market Level',
                translate: 'NAV.MARKET_LEVEL',
                type: 'collapsable',
                icon: 'business_center',
                isActive: false,
                children: [
                    {
                        id: 'market-level-list',
                        title: 'Market Level List',
                        type: 'item',
                        url: '/market-level/list',
                        isActive: false
                    },
                    {
                        id: 'market-level-add',
                        title: 'Add New Market Level',
                        type: 'item',
                        url: '/market-level/add'
                    }
                ]
            },
            {
                id: 'user-role',
                title: 'User Role',
                translate: 'NAV.USER_ROLE',
                type: 'collapsable',
                icon: 'supervisor_account',
                isActive: false,
                children: [
                    {
                        id: 'user-role-list',
                        title: 'User Role List',
                        type: 'item',
                        url: '/user-role/list',
                        isActive: false
                    },
                    {
                        id: 'user-role-add',
                        title: 'Add New User Role',
                        type: 'item',
                        url: '/user-role/add',
                        isActive: false
                    },
                    {
                        id: 'user-permission-add',
                        title: 'Set Permission',
                        type: 'item',
                        url: '/user-role/permission-manage',
                        isActive: false
                    }
                ]
            },
            {
                id: 'GEO_HIERARCHY',
                title: 'Geo Hierarchy',
                translate: 'NAV.USER_ROLE',
                type: 'collapsable',
                icon: 'place',
                isActive: false,
                children: [
                    {
                        id: 'VIEW_GEO_HIERARCHY',
                        title: 'Division',
                        type: 'item',
                        url: '/geo-hierarchy/division',
                        isActive: false
                    },
                    {
                        id: 'VIEW_GEO_HIERARCHY',
                        title: 'District',
                        type: 'item',
                        url: '/geo-hierarchy/district',
                        isActive: false
                    },
                    {
                        id: 'VIEW_GEO_HIERARCHY',
                        title: 'Thana',
                        type: 'item',
                        url: '/geo-hierarchy/thana',
                        isActive: false
                    },
                    {
                        id: 'VIEW_GEO_HIERARCHY',
                        title: 'Union/Town',
                        type: 'item',
                        url: '/geo-hierarchy/union-or-town',
                        isActive: false
                    }
                ]
            }
        ]
    }
];
